{
    "coordinates": [
        47.735000,
        -109.646111
    ],
    "tooltip": "Judith River",
    "title": "Judith River Formation",
    "country": "United States",
    "period": "Cretaceous",
    "alt": "TODO"
}
